<template>
  <VirtualCollection :cellSizeAndPositionGetter="cellSizeAndPositionGetter" :collection="collectionItems" :height="height" :width="width">
    <template slot="cell" slot-scope="props">
      <v-list-tile @click="toggle(props.data)">
        <v-list-tile-title>
          <v-layout>
            <v-flex class="done-icon pr-1">
              <v-icon v-show="items[props.data]">done</v-icon>
            </v-flex>
            <v-flex>{{ props.data }}</v-flex>
          </v-layout>
        </v-list-tile-title>
      </v-list-tile>
    </template>
  </VirtualCollection>
</template>
<script>
  import { getScrollbarSize } from '@/helpers/dom'

  export default {
    props: {
      items: Object,
    },
    data() {
      return {
        scrollbarSize: getScrollbarSize(),
        collectionItems: [],
        height: 200,
        width: 294,
        maxWidth: 0,
      }
    },
    methods: {
      cellSizeAndPositionGetter(item, index) {
        let width = this.maxWidth
        let height = 40
        let result = {
          width: width,
          height: height,
          x: 0,
          y: parseInt(index) * height,
        }
        return result
      },
      makeMaxWidths(items) {
        let result = items.reduce((accumulator, currentValue) => {
          let length = currentValue.length
          return accumulator > length ? accumulator : length
        }, 0)

        let checkMarkWidth = 30
        result = checkMarkWidth + (result * 6)

        // Match container width or larger
        let defaultWidth = this.width - this.scrollbarSize.width
        result = (result > defaultWidth) ? result : defaultWidth
        this.maxWidth = result
      },
      makeCollectionItems(items) {
        this.collectionItems = items.map(value => {
          return { data: value }
        })
      },
      async update(items) {
        let keys = Object.keys(items)
        this.makeCollectionItems(keys)
      },
      initialize(items) {
        let keys = Object.keys(items)
        this.makeMaxWidths(keys)
        this.makeCollectionItems(keys)
      },
      toggle(key) {
        this.$emit('toggle', key)
      },
    },
  }
</script>

<style scoped>
  .done-icon {
    flex: 0 0 30px;
  }
</style>